import RouteItem from ".";
//course SubMenu Pages
import Bpt from "../pages/courses/Bpt";
import Mpt from "../pages/courses/Mpt";

export const courseRoutes: RouteItem = {
  key: "router-course",
  title: "Courses",
  tooltip: "Courses",
  path: "/courses",
  enabled: true,
  appendDivider: true,
  showInHeader: true,
  subRoutes: [
    {
      key: "router-course-bpt",
      title: "Bachelor's of Physiotherapy",
      tooltip: "Bachelor's of Physiotherapy",
      path: "bachelor-of-physiotherapy",
      enabled: true,
      component: Bpt,
      appendDivider: true,
    },
    {
      key: "router-course-mpt",
      title: "Master's of Physiotherapy",
      tooltip: "Master's of Physiotherapy",
      path: "master-of-phsiotheraphy",
      enabled: true,
      component: Mpt,
      appendDivider: true,
    },
  ],
};
